import React from 'react';

import Advantages from '@/components/Base/StaticContent/Advantages';
import ConditionsTable from '@/components/Base/StaticContent/ConditionsTable';
import FAQ from '@/components/Base/StaticContent/FAQ';
import HowToIssueBusinessLoan from '@/components/Base/StaticContent/HowToIssueBusinessLoan';
import Information from '@/components/Base/StaticContent/Information';
import List from '@/components/Base/StaticContent/List';
import { STATIC_SECTIONS } from '@/constants';
import { usePageProps } from '@/hooks';
import { getCurrentPageType } from '@/utils';

const conformity = {
  advantages: Advantages,
  howToIssueBusinessLoan: HowToIssueBusinessLoan,
  forWhatPurposesProvided: List,
  conditionsTable: ConditionsTable,
  faq: FAQ,
  information: Information,
};

const componentProps = {
  forWhatPurposesProvided: {
    length: 4,
  },
};

function StaticContent() {
  const { params } = usePageProps();

  // Визначаємо тип сторінки залежно від params
  const pageType = getCurrentPageType({ params });

  const currentList = STATIC_SECTIONS?.[pageType] || null;

  if (!currentList) return null;

  return currentList.map((item) => {
    const CurrentComponent = conformity?.[item];

    return CurrentComponent ? (
      <CurrentComponent
        key={item}
        id={item}
        params={params}
        {...(componentProps?.[item] || {})}
      />
    ) : null;
  });
}

export default StaticContent;
